import { ActivatedRouteSnapshot } from '@angular/router';

export function getFromRouterHierarchy(route: ActivatedRouteSnapshot) {
  let queryParams = {};
  let params = {};
  let data = {};
  let pointer = route;
  while (pointer != null) {
    queryParams = { ...queryParams, ...pointer.queryParams };
    params = { ...params, ...pointer.params };
    data = { ...data, ...pointer.data };
    pointer = pointer.firstChild;
  }

  return {
    queryParams,
    params,
    data,
  };
}
